import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		historyList: [],
		isBack: 0,
		isLogin: '',
		backRenovate: 0,
		showPoint: -1,
		fromUrl: "",
		loadNum: 0,
		commentList: {},
		/**
		 * 在考勤缴费模块有个邀请新学员
		 * 路由跳转为/handle_payment ---> /new_class_info/235
		 * 这里的值为true的时候说明进行了邀请操作
		 * 邀请完成后返回原页面 this.$router.back(-2)
		 */
		hasInviteNewStudent: false,
		noGotoJiao: false,
		// role_cur: '',
		has_arr: [], // 用户权限有什么
		signInfo: { // 用户签约信息
			id_card_name: '',
			id_card: '',
			bank_card: '',
			bank_mobile: '',
			verify_code: '',
		},
		signInfoForeign: {
			national: '', // 国家名
			country: '', // 国籍（地区）代码
			card_type: '', // 证件类型id
			card_tName: '', // 证件类型
			id_card: '', // 证件号码
			real_name: '', // 姓名
			gender: '', // 性别
			birthday: '', // 出生日期
			image_urls: [], // 证件照片 URL 地址，仅支持 HTTPS 协议，不支持重定向，文件大小不超过 20M，仅支持 jpg/jpeg/png 格式
		},
	},
	mutations: {
		editIsLogin(state, val) {
			state.isLogin = val
		},
		editIsBack(state, val) {
			state.isBack = val
		},
		editCommentList(state, val) {
			state.commentList = val
		},
		editBackRenovate(state, val) {
			state.backRenovate = val
		},
		editHistoryList(state, val) {
			state.historyList = val
		},
		delHistoryList(state, val) {
			let historyList
			if (typeof(val) == 'string') historyList = state.historyList.filter(v => v != val)
			else historyList = state.historyList.filter(v => !val.includes(v))
			state.historyList = historyList
		},
		editnoGotoJiao(state, val) {
			state.noGotoJiao = val
		},
		edithasInviteNewStudent(state, val) {
			state.hasInviteNewStudent = val
		},
		editshowPoint(state, val) {
			state.showPoint = val
		},
		editfromUrl(state, val) {
			state.fromUrl = val
		},
		editloadNum(state, val) {
			state.loadNum = val
		},
		// 修改当前角色身份
		// editrole_cur(state, val) {
		// 	state.role_cur = val
		// },
		setHasArr(state, val) {
			state.has_arr = [...val]
			// 去重复
			state.has_arr = [...new Set(state.has_arr)]
			// 保存到本地
			// localStorage.setItem('has_arr', JSON.stringify(state.has_arr))
		},
		updateSignInfo(state, payload) {
			state.signInfo = {
				...state.signInfo,
				...payload
			};
		},
		resetSignInfo(state) {
			state.signInfo = {
				id_card_name: '',
				id_card: '',
				bank_card: '',
				bank_mobile: '',
				verify_code: '',
			};
		},
		updateSignInfoForeign(state, payload) {
			state.signInfoForeign = {
				...state.signInfoForeign,
				...payload
			};
		},
		resetSignInfoForeign(state) {
			state.signInfoForeign = {
				national: '', // 国家名
				country: '', // 国籍（地区）代码
				card_type: '', // 证件类型id
				card_tName: '', // 证件类型
				id_card: '', // 证件号码
				real_name: '', // 姓名
				gender: '', // 性别
				birthday: '', // 出生日期
				image_urls: [], // 证件照片 URL 地址，仅支持 HTTPS 协议，不支持重定向，文件大小不超过 20M，仅支持 jpg/jpeg/png 格式
			};
		},
	},
	actions: {},
	modules: {},
	plugins: [persistedState()] //添加插件
})


// WEBPACK FOOTER //
// ./src/store/index.js